export const PASSWORD_POLICY_MESSAGE =
  "Use at least 8 characters with uppercase, lowercase, a number and a special character (e.g. MyPass1!).";

export function isPasswordPolicyInvalid(password) {
  if (!password || password.length < 8) return true;
  if (!/[A-Z]/.test(password)) return true;
  if (!/[a-z]/.test(password)) return true;
  if (!/\d/.test(password)) return true;
  if (!/[!@#$%^&*(),.?":{}|<>_\-+=[\]\\/'`~;]/.test(password)) return true;
  return false;
}

export const COGNITO_USERNAME_MAX_LENGTH = 100;

export const USERNAME_POLICY_MESSAGE =
  "Username must be 1–100 characters and use only letters, numbers, and underscores (no spaces or special characters).";

const USERNAME_VALID_PATTERN = /^[a-zA-Z0-9_]+$/;

const USERNAME_INVALID_CHAR_PATTERN = /[!@#$%^&*()\-+=,.;:'"<>?/\\|`~\s]/g;

export function sanitizeCognitoUsernameInput(value) {
  return String(value ?? "")
    .replace(USERNAME_INVALID_CHAR_PATTERN, "")
    .slice(0, COGNITO_USERNAME_MAX_LENGTH);
}

export function normalizeCognitoUsername(value) {
  return sanitizeCognitoUsernameInput(value).toLowerCase();
}

export function isCognitoUsernameInvalid(value) {
  const trimmed = String(value ?? "").trim();
  if (!trimmed) return true;
  if (trimmed.length > COGNITO_USERNAME_MAX_LENGTH) return true;
  return !USERNAME_VALID_PATTERN.test(trimmed);
}
